import React, { useEffect } from 'react';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import './privacypolicy.css';
import Upperbox from '../components/Upperbox';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';

const Privacypolicy = () => {

  // 👇 Scroll to top whenever this page is loaded
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />

      <div className="privacy-policy-container">
        <h1 className="privacy-policy-main-title">Privacy Policy</h1>
        <div className="privacy-policy-section">

          <h2 className="privacy-title">Who We Are</h2>
          <p>Our website address is: <a href="https://www.sumukhataxfilers.com/">https://www.sumukhataxfilers.com/</a></p>
          <p>Litax (“us”, “we”, or “our”) is a tax preparation and consulting service provider. This privacy policy explains how we collect, use, disclose, and protect your personal information when you use our services.</p>
          
          <h2 className="privacy-title">Information We Collect</h2>
          <p>We may collect personal information from you when you:</p>
          <ul>
            <li>Visit our website</li>
            <li>Contact us for services</li>
            <li>Engage with us on social media</li>
          </ul>
          <p>The information we collect may include:</p>
          <ul>
            <li><strong>Personal Information:</strong> Name, address, email address, phone number, Social Security number, date of birth, financial details (income, deductions, tax returns), and other identifiers.</li>
            <li><strong>Device Information:</strong> Details about your computer, mobile device, or other device used to access our services, including IP address, browser type, and operating system.</li>
            <li><strong>Usage Information:</strong> Information about how you use our services, including pages visited, features used, and links clicked.</li>
          </ul>

          <h2 className="privacy-title">How We Use Information</h2>
          <p>Litax may also use your personal information to reach out to you about services we believe you may be interested in. We use this information to:</p>
          <ul>
            <li>Provide tax preparation and consulting services</li>
            <li>Communicate with you regarding your account and services</li>
            <li>Respond to your inquiries and requests</li>
            <li>Enhance our services and website</li>
            <li>Prevent fraud and abuse</li>
            <li>Comply with legal and regulatory requirements</li>
          </ul>
          <p>You will always have the option to opt-out of receiving direct communications. You may exercise this right to opt-out at any time.</p>

          <h2 className="privacy-title">Sharing Your Information</h2>
          <p>We will not share your mobile information with third parties or affiliates for marketing or promotional purposes. Other data, excluding text messaging opt-in information and consent, will not be shared with any third parties.</p>

          <h2 className="privacy-title">Data Security</h2>
          <p>We take reasonable steps to protect your personal information from unauthorized access, use, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is fully secure.</p>

          <h2 className="privacy-title">Your Rights</h2>
          <ul>
            <li>Access and review your personal information</li>
            <li>Correct inaccuracies in your personal information</li>
            <li>Request deletion of your personal information</li>
            <li>Opt-out of marketing communications</li>
            <li>Restrict processing of your personal information</li>
          </ul>

          <h2 className="privacy-title">Children’s Privacy</h2>
          <p>Our services are not intended for children under the age of 18. We do not knowingly collect personal information from children.</p>

          <h2 className="privacy-title">Changes to This Privacy Policy</h2>
          <p>We may update this privacy policy from time to time. Any material changes will be communicated by posting the updated policy on our website.</p>

          <h2 className="privacy-title">Contact Us</h2>
          <p>If you have any questions or concerns about this privacy policy, please contact us at:</p>
          <p>Phone: +1 (302)-200-2836</p>
          <p>Email: <a href="mailto:info@litaxfilers.com">info@litaxfilers.com</a></p>
        </div>
      </div>

      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Privacypolicy;
